module.exports = __webpack_public_path__ + "static/media/banner.ca537fa6.png";